import React from "react";

export const IcGoogle = ({className}) => {
    return (
        <svg className={className} width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M33.0001 17.382C33.0001 16.2351 32.9063 15.0925 32.7102 13.9617H16.8324V20.4388H25.9254C25.5495 22.5285 24.3362 24.3771 22.5636 25.5485V29.7564H27.9921C31.1702 26.8341 33.0001 22.5039 33.0001 17.382Z"
                fill="#4285F4"/>
            <path
                d="M16.8323 33.8214C21.3749 33.8214 25.2023 32.3317 27.9921 29.7604L22.5635 25.5525C21.0521 26.577 19.1077 27.1606 16.8323 27.1606C12.4413 27.1606 8.71582 24.2019 7.38016 20.2184H1.79224V24.5526C4.65148 30.238 10.4683 33.8214 16.8323 33.8214Z"
                fill="#34A853"/>
            <path
                d="M7.38425 20.2182C6.6777 18.1328 6.6777 15.8676 7.38425 13.7782V9.44794H1.79236C-0.597455 14.2024 -0.597455 19.8019 1.79236 24.5567L7.38425 20.2182Z"
                fill="#FBBC04"/>
            <path
                d="M16.8323 6.84011C19.2343 6.80337 21.5504 7.70549 23.2904 9.36248L28.0983 4.56277C25.0512 1.70607 21.0154 0.134713 16.8323 0.179649C10.4683 0.179649 4.64753 3.76692 1.79224 9.44811L7.38412 13.7823C8.71582 9.79489 12.4413 6.84011 16.8323 6.84011Z"
                fill="#EA4335"/>
        </svg>
    )
}
